const DNI_LETTERS = "TRWAGMYFPDXBNJZSQVHLCKE"
const CIF_CONTROL_LETTERS = "JABCDEFGHI"
const CIF_CONTROL_NUMERIC_PREFIXES = new Set(["A", "B", "E", "H"])
const CIF_CONTROL_LETTER_PREFIXES = new Set(["K", "P", "Q", "S", "W"])

export const normalizeSpanishTaxId = value =>
  String(value || "")
    .toUpperCase()
    .replace(/[\s-]/g, "")

const isValidDni = value => {
  if (!/^\d{8}[A-Z]$/.test(value)) return false
  const number = Number(value.slice(0, 8))
  return value[8] === DNI_LETTERS[number % 23]
}

const isValidNie = value => {
  if (!/^[XYZ]\d{7}[A-Z]$/.test(value)) return false
  const prefix = { X: "0", Y: "1", Z: "2" }[value[0]]
  const number = Number(`${prefix}${value.slice(1, 8)}`)
  return value[8] === DNI_LETTERS[number % 23]
}

const isValidCif = value => {
  if (!/^[ABCDEFGHJNPQRSUVW]\d{7}[0-9A-Z]$/.test(value)) return false

  const digits = value.slice(1, 8)
  let evenSum = 0
  let oddSum = 0

  for (let index = 0; index < digits.length; index += 1) {
    const digit = Number(digits[index])
    if ((index + 1) % 2 === 0) {
      evenSum += digit
    } else {
      const doubled = digit * 2
      oddSum += Math.floor(doubled / 10) + (doubled % 10)
    }
  }

  const controlDigit = (10 - ((evenSum + oddSum) % 10)) % 10
  const controlLetter = CIF_CONTROL_LETTERS[controlDigit]
  const controlChar = value[8]
  const prefix = value[0]

  if (CIF_CONTROL_NUMERIC_PREFIXES.has(prefix)) {
    return controlChar === String(controlDigit)
  }

  if (CIF_CONTROL_LETTER_PREFIXES.has(prefix)) {
    return controlChar === controlLetter
  }

  return controlChar === String(controlDigit) || controlChar === controlLetter
}

export const isValidSpanishTaxId = value => {
  const normalized = normalizeSpanishTaxId(value)
  if (!normalized) return false
  if (/^\d{8}[A-Z]$/.test(normalized)) return isValidDni(normalized)
  if (/^[XYZ]\d{7}[A-Z]$/.test(normalized)) return isValidNie(normalized)
  if (/^[ABCDEFGHJNPQRSUVW]\d{7}[0-9A-Z]$/.test(normalized)) {
    return isValidCif(normalized)
  }
  return false
}

export const splitFullName = (fullName = "") => {
  const parts = fullName.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return { given: "", surname: "", surname2: "" }
  if (parts.length === 1) return { given: parts[0], surname: "", surname2: "" }
  if (parts.length === 2)
    return { given: parts[0], surname: parts[1], surname2: "" }
  // 3+ → first token = given, last two = surnames
  return {
    given: parts.slice(0, parts.length - 2).join(" "),
    surname: parts[parts.length - 2],
    surname2: parts[parts.length - 1],
  }
}
